import { getUrl } from './api'
import { getReq } from './appService'

// 获取Weapopns列表
export const getWeapons = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v1/weapons', chainId, params)
  getReq(url, cb)
}

// 获取Weapopns列表
export const getWeaponsV2 = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v2/weapons', chainId, params)
  getReq(url, cb)
}

// 获取Weapopns列表
export const getWeaponsV3 = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v3/weapons', chainId, params)
  getReq(url, cb)
}
